import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, queryFilterCondition, getFeeBillFile } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const PrepaidCardHistory = Loadable({
    loader: () => import('./PrepaidCardHistory'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          transactionHistoryState: state.transactionHistoryState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          queryFilterCondition,
          getFeeBillFile,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/prepaid-card-history`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <PrepaidCardHistory {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
